import { render, staticRenderFns } from "./RequestCardList.vue?vue&type=template&id=a01e1068"
import script from "./RequestCardList.vue?vue&type=script&lang=js"
export * from "./RequestCardList.vue?vue&type=script&lang=js"
import style0 from "./RequestCardList.vue?vue&type=style&index=0&id=a01e1068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports